import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const UserManagementPage = lazyWithRetry(
  () => import("./ui/pages/UserManagementPage"),
  "UserManagementPage",
);

const usersRoutes = buildRoutes([
  {
    path: "/developer/users",
    element: UserManagementPage,
    roles: [5],
  },
]);

export default usersRoutes;